import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Divider,
  Grid,
  Typography
} from '@material-ui/core';

const styles = theme => ({
  root: {
    margin: '30px 0px',
  },
  nameCell: {
    marginLeft: '10px',
  },
  valueCell: {
    marginLeft: '10px',
  },
  name: {
    fontWeight: 700,
  },
});

class CompanyDetail extends Component {

  render() {
    const { classes, name, value } = this.props;
    return (
      <Grid
        container
        alignItems={"center"}
        direction={"row"}
        justify={"center"}
        className={classes.root}
      >
        <Grid item xs={12} sm={2} md={1} className={classes.nameCell}>
          <Typography variant="subheading" gutterBottom className={classes.name}>{name}</Typography>
        </Grid>
        <Grid item xs={12} sm={5} md={4} className={classes.valueCell}>
          <Typography variant="subheading" gutterBottom>{value}</Typography>
        </Grid>
        <Divider />
      </Grid>
    );
  }
};

CompanyDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(CompanyDetail);



// WEBPACK FOOTER //
// ./src/components/index/CompanyDetail.js